import { useMutation } from "@apollo/client";
import {
  Button,
  Grid,
  PasswordInput,
  ScrollArea,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { CREATE_LOAN_PROVIDER_STAFF } from "apollo/mutuations";
import { LOAN_PROVIDER_STAFF } from "apollo/queries";

const StaffAddModal = ({ setOpened, size, activePage, refetch }) => {
  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      temporary_password: "",
      role: "",
    },
    validate: {
      name: (value) => (!value ? "Name is required" : null),
      email: (value) =>
        !value
          ? "Email is required"
          : !/^\S+@\S+$/.test(value)
            ? "Invalid email"
            : null,
      phone: (value) => (!value ? "Phone is required" : null),
      temporary_password: (value) =>
        !value
          ? "Temporary password is required"
          : value.length < 8
            ? "Password must be at least 8 characters"
            : null,
      role: (value) => (!value ? "Role is required" : null),
    },
  });

  const [createStaff, { loading }] = useMutation(CREATE_LOAN_PROVIDER_STAFF, {
    update(cache, { data: { createLoanProviderStaff } }) {
      const existingData = cache.readQuery({
        query: LOAN_PROVIDER_STAFF,
        variables: {
          first: parseInt(size),
          page: activePage,
          search: "",
          role: null,
          orderBy: [
            {
              column: "created_at",
              order: "DESC",
            },
          ],
        },
      });

      if (existingData) {
        cache.writeQuery({
          query: LOAN_PROVIDER_STAFF,
          variables: {
            first: parseInt(size),
            page: activePage,
            search: "",
            role: null,
            orderBy: [
              {
                column: "created_at",
                order: "DESC",
              },
            ],
          },
          data: {
            loanProviderStaff: {
              data: [
                createLoanProviderStaff,
                ...existingData.loanProviderStaff.data,
              ],
              paginatorInfo: existingData.loanProviderStaff.paginatorInfo,
            },
          },
        });
      }
    },
    onCompleted: () => {
      showNotification({
        title: "Success",
        message: "Staff member added successfully",
        color: "green",
      });
      form.reset();
      setOpened(false);
      refetch();
    },
    onError: (error) => {
      showNotification({
        title: "Error",
        message: error.message || "Failed to add staff member",
        color: "red",
      });
    },
  });

  const handleSubmit = (values) => {
    createStaff({
      variables: values,
    });
  };

  return (
    <div>
      <div
        style={{
          fontSize: "18px",
          fontWeight: 600,
          marginBottom: "10px",
          marginTop: "30px",
        }}
      >
        Add Staff Member
      </div>

      <ScrollArea style={{ height: "75vh" }} offsetScrollbars>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Grid>
            <Grid.Col span={12}>
              <TextInput
                required
                label="Full Name"
                placeholder="Enter full name"
                {...form.getInputProps("name")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <TextInput
                required
                label="Email"
                placeholder="Enter email address"
                type="email"
                {...form.getInputProps("email")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <TextInput
                required
                label="Phone Number"
                placeholder="0911234567"
                {...form.getInputProps("phone")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <PasswordInput
                required
                label="Temporary Password"
                placeholder="Enter temporary password"
                description="User will be required to change this on first login"
                {...form.getInputProps("temporary_password")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <Select
                required
                label="Role"
                placeholder="Select role"
                data={[
                  { value: "MAKER", label: "Maker" },
                  { value: "CHECKER", label: "Checker" },
                  { value: "APPROVER", label: "Approver" },
                ]}
                {...form.getInputProps("role")}
              />
            </Grid.Col>

            <Grid.Col span={3}>
              <Button
                type="submit"
                loading={loading}
                fullWidth
                style={{ backgroundColor: "#FF6A00", marginTop: "10px" }}
              >
                Save
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </ScrollArea>
    </div>
  );
};

export default StaffAddModal;
